<div class="quick-actions-container">
  <div class="action-card primary cursor-pointer" (click)="openPsychometricTest()">
    <img src="../../../assets/images/Intersect.png" alt="" class="bg-shape top-left" />
    <div class="card-content">
      <h3>Psychometric Test</h3>
      <a href="javascript:void(0)" class="action-link">Take Test &rarr;</a>
    </div>
    <div class="card-illustration">
      <img src="../../../assets/images/PsychometricTest.png" alt="Psychometric Test" />
    </div>
    <img src="../../../assets/images/Intersect (1).png" alt="" class="bg-shape bottom-right" />
  </div>

  <div class="action-card secondary cursor-pointer" (click)="openExploreColleges()">
    <img src="../../../assets/images/Intersect (2).png" alt="" class="bg-shape top-left" />
    <div class="card-content">
      <h3 class="text-dark">Explore Colleges</h3>
      <a href="javascript:void(0)" class="action-link text-dark">Explore now &rarr;</a>
    </div>
    <div class="card-illustration">
      <img src="../../../assets/images/ExploreColleges.png" alt="Explore Colleges" />
    </div>
    <img src="../../../assets/images/Intersect (3).png" alt="" class="bg-shape bottom-right" />
  </div>

  <div class="action-card primary cursor-pointer" (click)="openPeerConnect()">
    <img src="../../../assets/images/Intersect.png" alt="" class="bg-shape top-left" />
    <div class="card-content">
      <h3>View peers</h3>
      <a href="javascript:void(0)" class="action-link">View &rarr;</a>
    </div>
    <div class="card-illustration">
      <img src="../../../assets/images/graduation-cap.png" alt="View peers" />
    </div>
    <img src="../../../assets/images/Intersect (1).png" alt="" class="bg-shape bottom-right" />
  </div>
</div>
